import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import moment from "moment";

import BirthdayIcon from "../../../../Assets/Logo/BirthdayIcon.svg";
import { useStyles } from "./DashboardBirthday.css";

class DashboardBirthday extends Component {
  render() {
    const { staffList, studentList, classes } = this.props;
    let staffBirthdayFilter = staffList.filter((data) => {
      return (
        moment(data.dateOfBirth)
          .format("MM")
          .indexOf(moment(new Date()).format("MM")) !== -1 &&
        moment(data.dateOfBirth)
          .format("DD")
          .indexOf(moment(new Date()).format("DD")) !== -1
      );
    });
    let studentBirthdayFilter = studentList.filter((data) => {
      return (
        moment(data.dob_in_AD)
          .format("MM")
          .indexOf(moment(new Date()).format("MM")) !== -1 &&
        moment(data.dob_in_AD)
          .format("DD")
          .indexOf(moment(new Date()).format("DD")) !== -1
      );
    });
    return (
      <>
        <Grid item xs={12} sm={12} md={4} xl={4} lg={4}>
          <Paper className={classes.paper}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: 10,
              }}
            >
              <img
                src={BirthdayIcon}
                alt="Birthday"
                style={{ width: 30, height: 30 }}
              />
              <div style={{ marginLeft: 10, fontSize: 18, fontWeight: "bold" }}>
                Staff's Birthday
              </div>
            </div>
            <Divider />
            {staffBirthdayFilter.length !== 0 ? (
              <div>
                <div style={{ fontSize: 16, fontWeight: "bold" }}>Staff</div>
                {staffBirthdayFilter.slice(0, 3).map((staff, index) => (
                  <ListItem divider key={index}>
                    <div style={{ flexGrow: 1 }}>{staff.fullName}</div>
                    <div>{staff.department}</div>
                  </ListItem>
                ))}
              </div>
            ) : (
              <div className={classes.body}>
                There is noone's birthday today
              </div>
            )}
          </Paper>
        </Grid>
        <Grid item xs={12} sm={12} md={4} xl={4} lg={4}>
          <Paper className={classes.paper}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: 10,
              }}
            >
              <img
                src={BirthdayIcon}
                alt="Birthday"
                style={{ width: 30, height: 30 }}
              />
              <div style={{ marginLeft: 10, fontSize: 18, fontWeight: "bold" }}>
                Student's Birthday
              </div>
            </div>
            <Divider />
            {studentBirthdayFilter.length !== 0 ? (
              <div>
                <div style={{ fontSize: 16, fontWeight: "bold" }}>Staff</div>
                {studentBirthdayFilter.slice(0, 3).map((student, index) => (
                  <ListItem divider key={index}>
                    <div style={{ flexGrow: 1 }}>
                      {student.firstName} {student.lastName}
                    </div>
                    <div>{student.studentClass}</div>
                  </ListItem>
                ))}
              </div>
            ) : (
              <div className={classes.body}>
                There is noone's birthday today
              </div>
            )}
          </Paper>
        </Grid>
      </>
    );
  }
}

export default withStyles(useStyles)(DashboardBirthday);
